import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text text-ellipsis overflow-hidden pb-md+ pt-sm md:pt-sm+" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.data), 1));
}
